import { render } from "./ShoppingList.vue?vue&type=template&id=006bf2ae"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"
script.render = render

export default script